"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcRoutes = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const route_utils_1 = require("../route-utils");
const not_authenticated_1 = require("./not-authenticated");
const not_authorized_1 = require("./not-authorized");
const silent_callback_1 = require("./silent-callback");
const OidcRoutesComponent = ({ notAuthenticated = react_1.default.createElement(not_authenticated_1.NotAuthenticated, null), notAuthorized = react_1.default.createElement(not_authorized_1.NotAuthorized, null), callbackComponent, sessionLost, configuration, children, }) => {
    const [path, setPath] = react_1.useState(window.location.pathname);
    const setNewPath = () => setPath(window.location.pathname);
    react_1.useEffect(() => {
        setNewPath();
        window.addEventListener('popstate', setNewPath, false);
        return () => window.removeEventListener('popstate', setNewPath, false);
    });
    const silentCallbackPath = route_utils_1.getPath(configuration.silent_redirect_uri);
    const callbackPath = route_utils_1.getPath(configuration.redirect_uri);
    switch (path) {
        case callbackPath:
            return react_1.default.createElement(react_1.default.Fragment, null, callbackComponent);
        case silentCallbackPath:
            return react_1.default.createElement(silent_callback_1.SilentCallback, null);
        case '/authentication/not-authenticated':
            return react_1.default.createElement(react_1.default.Fragment, null, notAuthenticated);
        case '/authentication/not-authorized':
            return react_1.default.createElement(react_1.default.Fragment, null, notAuthorized);
        case '/authentication/session-lost':
            return react_1.default.createElement(react_1.default.Fragment, null, sessionLost);
        default:
            return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
};
exports.OidcRoutes = react_1.memo(OidcRoutesComponent);
//# sourceMappingURL=oidc-routes.js.map